import React, { Fragment, useState } from "react"
import { FaEdit, FaTrashAlt } from "react-icons/fa"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { removePosTerminal } from "@redux"
import { ConfirmationModal, IconButton } from "components"
import SmptPcPosModal from "./SmptPcPosModal"
import classes from "./SmptPcPosCard.module.scss"

const SmptPcPosCard = (props) => {
  const { pcPosTerminal } = props

  const [t, i18n] = useTranslation()

  const dispatch = useDispatch()

  const accountId =
    useSelector(state => state.userAccountInfo._id)

  const [openPcPosModal, setOpenPcPosModal] = useState(false)
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false)

  const handleDeletePos = () => {
    dispatch(
      removePosTerminal(pcPosTerminal._id, accountId)
    )

    setOpenConfirmationModal(false)
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <div className={classes["card"]}>
        <span
          className={clsx(
            classes["text"],
            isLtr && classes["text-ltr"]
          )}
        >
          {pcPosTerminal.name}
        </span>

        <IconButton
          icon={FaEdit}
          onClick={() => setOpenPcPosModal(true)}
          color="var(--color-success)"
          className={classes["button"]}
          size={20}
        />

        <IconButton
          icon={FaTrashAlt}
          color="var(--color-danger)"
          onClick={() => setOpenConfirmationModal(true)}
          className={classes["button"]}
          size={20}
        />
      </div>

      <ConfirmationModal
        title={t("آیا_می_خواهید_این_کارتخوان_را_حذف_کنید")}
        show={openConfirmationModal}
        onConfirm={handleDeletePos}
        onHide={() => setOpenConfirmationModal(false)}
      />

      <SmptPcPosModal
        posTerminalForEdit={pcPosTerminal}
        openPcPosModal={openPcPosModal}
        setOpenPcPosModal={setOpenPcPosModal}
      />
    </Fragment>
  )
}

export default SmptPcPosCard